var subsetting = function (column) {
    var $ = jQuery;
    var settings = {
        value_show: "on",
        subfield: '.ac-column-setting'
    };
    function initState($setting, $input) {
        var value = $input.filter(':checked').val();
        var $subfields = $setting.find(settings.subfield);
        if (settings.value_show === value) {
            $subfields.show();
        }
        else {
            $subfields.hide();
        }
    }
    var $column = column.$el;
    var $settings = $column.find('.ac-column-setting--filter,.ac-column-setting--sort,.ac-column-setting--edit');
    $settings.each(function () {
        var $setting = $(this);
        var $input = $(this).find('.ac-setting-input input[type="radio"]');
        initState($setting, $input);
        $input.on('change', function () {
            initState($setting, $input);
        });
    });
};
export default subsetting;
